import Filter from './modules/brief/Filter'
import Login from './modules/common/Login'
import Period from './modules/common/Period'
import Subject from './modules/brief/Subject'
import DefaultChartData from './modules/statistics/DefaultChartData'
import DefaultTableData from './modules/brief/DefaultTableData'

export default {
  modules: {
    DefaultChartData,
    DefaultTableData,
    Filter,
    Login,
    Period,
    Subject
  }
}
